module.exports = __webpack_public_path__ + "img/content-15@2x.ce08940.png";